<template>
  <div class="iphoneBox">
    <header>
      <h2>Khi đủ điều kiện tham gia chương trình,</h2>
      <h3>người chơi nhận được mã số dự thưởng N</h3>
      <img class="introduction_banner" src="../assets/image/introduction_banner.png" alt="gift" />
    </header>
    <div class="rule">
      <ul class="ruleContent">
        <li>
          <h4>1.Cách thực tiến hành chương trình khuyến mại và tham gia để trúng thưởng:</h4>
          <p>Người dùng đăng ký tham gia chương trình với tài khoản Facebook của mình bằng cách thao tác trên: http://vngaynay.vn/ theo các bước như sau.</p>
          <ul>
            <li>- Bước 1: Truy cập vào đường link: http://vngaynay.vn/. Click chọn “đăng nhập bằng tài khoản facebook”. Sau khi đăng nhập thành công chuyển sang bước 2.</li>
            <li>- Bước 2: Hệ thống sẽ tự động chuyển sang giao diện mới với thông báo “Tham gia chương trình khuyến mại Đọc tin hay, rinh quà liền tay” và khách hàng có thể điền các thông tin bắt buộc sau: Họ và tên, số chứng minh nhân dân, số điện thoại, địa chỉ email. Sau khi điền xong khách hàng lick vào nút “Gửi”. Nếu thông tin hợp lệ hệ thống sẽ gửi thông  báo về với nội dung “Cảm ơn quý khách đã tham gia chương trình khuyến mại Đọc tin hay, rinh quà liền tay của công ty TNHH Công Nghệ Mạng Thông Tin Việt Nam.</li>
            <li>- Bước 3: Sau khi đăng ký tham gia chương trình quý khách hàng thực hiện các thao tác sau để nhận mã quay số trúng thưởng.</li>
          </ul>
          <p>Người dùng chia sẻ bài viết lên trang Facebook cá nhân ở chế độ công khai, hoặc chia sẻ cho bạn bè trên Facebook, người dùng sẽ được tích lũy điểm kinh vào tài khoản Facebook đã được ghi nhận trên hệ thống.</p>
          <div>
            <p> Cách tích lũy điểm</p>
            <table class="tableInfo" rules='all'>
              <tr>
                <th>Thao tác</th>
                <th>Số điểm cộng</th>
                <th>Ghi chú</th>
              </tr>
              <tr>
                <td>Chia sẻ bài viết lên Facebook cá nhân để ở chế độ công khai</td>
                <td>2</td>
                <td>Mỗi ngày được cộng tối đa 10 điểm</td>
              </tr>
              <tr>
                <td>Chia sẻ bài viết cho bạn bè bằng hai cách sau: Đăng lên tường bạn bè hoặc gửi qua tin nhắn face book.</td>
                <td>1</td>
                <td>Mỗi ngày được cộng tối đa 20 điểm</td>
              </tr>
            </table>
          </div>
          <p>Mỗi tuần tích lũy đủ 50 điểm kinh nghiệm, sẽ được hệ thống tặng 01 mã số dự thưởng qua Facebook cá nhân của người dùng. Không giới hạn mã số dự thưởng.Mẫu mã số dự thưởng như sau: Bao gồm 7 ký tự chữ số: VD: 1234567.</p>
        </li>
        <li>
          <h4>2.Thời gian thực hiện của chương trình khuyến mại:</h4>
          <ol>
            <li>Thời gian thực hiện chương trình: 0h ngày 05/11/2018 đến 0h ngày 30/06/2019</li>
            <li>Hạn chót tham gia dự thưởng: 23h59 phút chủ nhật hàng tuần</li>
            <li>Thời gian công bố giải thưởng: 17h thứ Hai hàng tuần</li>
            <li>Thời gian trao giải: 15 ngày làm việc kể từ ngày có kết quả của từng đợt quay thưởng.</li>
          </ol>
        </li>
        <li>
          <h4>3.Quy định về mã số trúng thưởng:</h4>
          <p>Khi bạn tham gia đổi thưởng, hệ thống sẽ phát một dãy số gồm 7 chữ số, gọi là vé dự thưởng.</p>
          <p>Việc quay thưởng được thực hiện công khai để chọn ra người chiến thắng trên Fanpage: https://www.facebook.com/vngaynay/</p>

          <ul>
            <li>Thời gian: 17h ngày 01/7/2019;</li>
            <li>Địa điểm: Trang Fanpage chính thức của VN Ngày Nay (link:https://www.facebook.com/vngaynay/
Mỗi tuần một sản phẩm, chỉ có 01 giải được trao.</li>
          </ul>
        </li>
        <li>
          <h4>4. Cơ cấu giải thưởng:</h4>
          <table class="tableInfo" rules='all'>
            <tr>
              <th>Cơ cấu giải thưởng</th>
              <th>Nội dung giải thưởng </th>
              <th>Trị giá giải thưởng (VNĐ) </th>
              <th>Số giải</th>
              <th>Thành tiền (VNĐ)</th>
            </tr>
            <tr>
              <td>Giải nhất	</td>
              <td>Xe máy Wave RSX FI 2017 (phiên bản phanh đĩa vành nan hoa) + 4.500.000 VNĐ
                  Hoặc
                  Điện thoại iPhone X 64GB Gray</td>
              <td>26.990.000</td>
              <td>34</td>
              <td>917.660.000</td>
            </tr>
          </table>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {MessageBox} from 'element-ui';
import lang from "element-ui/lib/locale/lang/vi";
import locale from "element-ui/lib/locale";
locale.use(lang);

export default {
  name: "introduction",
  mounted() {
    MessageBox.alert('Nhằm đem đến trải nghiệm tốt nhất cho người dùng, hệ thống xin thông báo, chương trình "Mỗi tuần 01 xe máy" sẽ tạm ngưng hoạt động vào ngày 02/07/2019. Chương trình mới sẽ mở sớm nhất có thể. Cảm ơn sự ủng hộ của các bạn trong thời gian qua.',"Thông báo",
    {
      dangerouslyUseHTMLString:true,
      center:true
    })
  },
};
</script>
<style scoped>
.iphoneBox {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  text-align: center;
  color: #ffffff;
  background-color: #fc5755;
}
h2,
h3,h4 {
  color: #ffffff;
  margin: 0;
  padding: 0;
}
h2 {
  padding-top: 20px;
  padding-bottom: 10px;
}
.introduction_banner {
  display: inline-block;
  font-size: 0;
  margin: 20px 0;
}
.rule {
  display: block;
  width: 60%;
  margin: 0 auto;
  padding-bottom: 10px;
}
.ruleContent {
  display: block;
  text-align: left;
}
.tableInfo{
  border: 1px solid #ffffff;
  text-align: center;
}
</style>





// WEBPACK FOOTER //
// Introduction.vue?425cda67